import { render } from "./OnlineUsersWidget.vue?vue&type=template&id=a5debdaa&scoped=true"
import script from "./OnlineUsersWidget.vue?vue&type=script&lang=js"
export * from "./OnlineUsersWidget.vue?vue&type=script&lang=js"

import "./OnlineUsersWidget.vue?vue&type=style&index=0&id=a5debdaa&scoped=true&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5debdaa"]])

export default __exports__